import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import {
  ConservazioneCaricaDocumentoModello730Step2Component
} from './conservazione-carica-documento-modello-730-step2';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('home.conservazione-carica-documento-modello-730-step2', {
            url: '/conservazione-carica-modello-730',
            ncyBreadcrumb: {
                label: 'Carica Modello 730',
                parent: 'home.conservazione'
            },
            data: {
                authorisationLevel: 1,
                pageTitle: 'Conservazione Carica Documento'
            },
            'views': {
                'homeContent': {
                    template: '<conservazione-carica-documento-modello-730-step2 flex="100"></conservazione-carica-documento-modello-730-step2>'
                }
            }
        });
};

stateConfig.$inject = ['$stateProvider'];

export const ConservazioneCaricaDocumentoModello730Step2Module: string = ng
    .module('conservazione-carica-documento-modello-730-step2', [
        'ui.bootstrap',
        uiRouter,
    ])
    .component('conservazioneCaricaDocumentoModello730Step2', ConservazioneCaricaDocumentoModello730Step2Component)
    .config(stateConfig)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/conservazione-carica-documento-modello-730-step2/conservazione-carica-documento-modello-730-step2.module.ts